import { render, staticRenderFns } from "./pets-allowed.vue?vue&type=template&id=7312df6a&scoped=true"
import script from "./pets-allowed.vue?vue&type=script&lang=js"
export * from "./pets-allowed.vue?vue&type=script&lang=js"
import style0 from "./pets-allowed.vue?vue&type=style&index=0&id=7312df6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312df6a",
  null
  
)

export default component.exports